<style scoped>
.card {
  margin: 10px;
}

.card-title {
  color: #676a6c;
}
</style>

<template>
  <div>
    <div>
      <Button
        style="margin-left:10px"
        type="primary"
        @click="archiveSearch"
      >归档查询</Button>
      <Row>
        <Col span="6">
          <Card class="card">
            <p slot="title" class="card-title">项目总数</p>
            <div>
              <h1>{{detail.projectcount}}</h1>
            </div>
          </Card>
        </Col>
        <Col span="6">
          <Card class="card">
            <p slot="title" class="card-title">Android归档总数</p>
            <div>
              <h1>{{detail.apkcount}}</h1>
            </div>
          </Card>
        </Col>
        <Col span="6">
          <Card class="card">
            <p slot="title" class="card-title">iOS归档总数</p>
            <div>
              <h1>{{detail.ipacount}}</h1>
            </div>
          </Card>
        </Col>
        <Col span="6">
          <Card class="card">
            <p slot="title" class="card-title">H5归档总数</p>
            <div>
              <h1>{{detail.h5count}}</h1>
            </div>
          </Card>
        </Col>
      </Row>

      <Card class="card">
        <p slot="title" class="card-title">发版流水</p>
        <Table :columns="tdata.col_data" :data="tdata.current_data"></Table>
      </Card>
      <!-- <Row>
        <Col span="24">
          <Card class="card">
            <p slot="title" class="card-title">H5归档数排行</p>
            <div>
              <div id="H5DistChart" :style="{width: '100%', height: '300px'}"></div>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <Card class="card">
            <p slot="title" class="card-title">Android归档数排行</p>
            <div>
              
              <div id="androidDistChart" :style="{width: '100%', height: '300px'}"></div>
            </div>
          </Card>
        </Col>
        <Col span="12">
          <Card class="card">
            <p slot="title" class="card-title">iOS归档数排行</p>
            <div>
              
              <div id="IOSDistChart" :style="{width: '100%', height: '300px'}"></div>
            </div>
          </Card>
        </Col>
      </Row>-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      androiddistrank: [],
      iosdistrank: [],
      h5distrank: [],
      tdata: {
        current_data: [],
        col_data: [
          {
            title: "类型",
            key: "distType",
            width: 150,
          },
          {
            title: "应用",
            key: "appname",
          },
          {
            title: "项目",
            key: "projectname",
          },
          {
            title: "提交人",
            key: "createDisplayName",
            width: 200,
          },
          {
            title: "时间",
            key: "createTimeNick",
            width: 200,
          },
        ],
      },
    };
  },
  methods: {
    getDistLatest() {
      let _this = this;
      this.$http.get({
        method: "mqms/pkgpub/getDistLatest",
        params: {
          count: 30,
        },
        success: function (data) {
          _this.tdata.current_data = data;
        },
        failure(code, msg) {},
      });
    },
    getDetail() {
      let _this = this;
      this.$http.get({
        method: "mqms/dashboard/detail",
        params: {},
        success: function (data) {
          _this.detail = data;
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    getAndroidDistUserRank() {
      let _this = this;
      this.$http.get({
        method: "mqms/dashboard/androiddistuserrank",
        params: {},
        success: function (data) {
          _this.androiddistrank = data;
          _this.drawAndroidDistLine();
        },
      });
    },
    drawAndroidDistLine() {
      let xAxisData = [];
      for (let i = 0; i < this.androiddistrank.length; i++) {
        // if(i==10){
        //   break;
        // }
        xAxisData.push(this.androiddistrank[i][1]);
      }
      let seriesData = [];
      for (let i = 0; i < this.androiddistrank.length; i++) {
        // if(i==10){
        //   break;
        // }
        seriesData.push(this.androiddistrank[i][0]);
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("androidDistChart")
      );
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        color: ["#3398DB"],
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: -45,
          },
          type: "category",
          data: xAxisData,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "次数",
            type: "bar",
            data: seriesData,
          },
        ],
      });
    },
    getIOSDistUserRank() {
      let _this = this;
      this.$http.get({
        method: "mqms/dashboard/iosdistuserrank",
        params: {},
        success: function (data) {
          _this.iosdistrank = data;
          _this.drawIOSDistLine();
        },
      });
    },
    drawIOSDistLine() {
      let xAxisData = [];
      for (let i = 0; i < this.iosdistrank.length; i++) {
        // if(i==10){
        //   break;
        // }
        xAxisData.push(this.iosdistrank[i][1]);
      }
      let seriesData = [];
      for (let i = 0; i < this.iosdistrank.length; i++) {
        // if(i==10){
        //   break;
        // }
        seriesData.push(this.iosdistrank[i][0]);
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("IOSDistChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        color: ["#3398DB"],
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: -45,
          },
          type: "category",
          data: xAxisData,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "次数",
            type: "bar",
            data: seriesData,
          },
        ],
      });
    },
    getH5DistUserRank() {
      let _this = this;
      this.$http.get({
        method: "mqms/dashboard/h5distuserrank",
        params: {},
        success: function (data) {
          _this.h5distrank = data;
          _this.drawH5DistLine();
        },
      });
    },
    archiveSearch() {
      this.$router.push("/archivesearch");
    },
    drawH5DistLine() {
      let nums = 20;
      let xAxisData = [];
      for (let i = 0; i < this.h5distrank.length; i++) {
        xAxisData.push(this.h5distrank[i][1]);
      }
      let seriesData = [];
      for (let i = 0; i < this.h5distrank.length; i++) {
        seriesData.push(this.h5distrank[i][0]);
      }
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("H5DistChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        color: ["#3398DB"],
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: -45,
          },
          type: "category",
          data: xAxisData,
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "次数",
            type: "bar",
            data: seriesData,
          },
        ],
      });
    },
  },
  mounted() {
    this.getDetail();
    this.getDistLatest();
    // this.getAndroidDistUserRank();
    // this.getIOSDistUserRank();
    // this.getH5DistUserRank();
  },
};
</script>